/* sync-v11 */
const ONORS_STORAGE_KEY = 'onors-weight-result';
const KG_PER_LB = 0.45359237;
const WF_REFERENCE_WEIGHT = 280;
const WF_REFERENCE_LOSS_LB = 17;
const WF_REFERENCE_STEP = 4;
const WF_WEIGHT_STEP_SCALE = 90;
const PERSONALIZED_TAB_STEP_SCALE = 1.2;

const WF_OUTER = [[478, 73], [468, 78], [455, 92], [452, 124], [456, 133], [445, 148], [448, 157], [449, 148], [454, 144], [454, 159], [466, 169], [432, 181], [412, 199], [406, 223], [403, 280], [383, 316], [367, 371], [354, 398], [354, 411], [359, 427], [370, 438], [367, 406], [372, 406], [375, 417], [379, 419], [382, 381], [387, 380], [390, 425], [420, 533], [417, 599], [437, 700], [435, 719], [424, 736], [425, 744], [453, 748], [468, 746], [472, 740], [467, 719], [467, 681], [481, 615], [480, 551], [486, 542], [491, 552], [490, 619], [503, 677], [505, 719], [500, 740], [503, 745], [541, 747], [547, 744], [548, 736], [537, 719], [534, 697], [553, 602], [551, 528], [579, 431], [583, 379], [589, 381], [592, 419], [596, 417], [599, 406], [604, 406], [601, 437], [614, 424], [617, 397], [604, 371], [584, 305], [568, 280], [566, 231], [560, 201], [541, 182], [505, 169], [506, 165], [516, 159], [521, 160], [526, 153], [524, 139], [517, 127], [512, 86], [500, 74]];
const WF_INTERIOR = [[[472, 376], [484, 406], [490, 429], [491, 441], [493, 441], [492, 403], [499, 384], [497, 384], [490, 393], [487, 394], [474, 376]], [[550, 226], [550, 262], [545, 272], [531, 280], [501, 275], [519, 284], [548, 282], [562, 312], [530, 345], [566, 322], [584, 364], [579, 333], [554, 277], [556, 254]], [[421, 222], [416, 247], [418, 278], [404, 299], [388, 352], [404, 320], [440, 342], [409, 312], [410, 301], [423, 278], [449, 282], [465, 276], [437, 278], [423, 268]]];
const WF_CX = 486.0;
const WF_FY = 73.0;
const WF_FH = 676.0;
const WF_K = 0.42;
const WF_PROFILE = [[0, 0.06], [0.1, 0.08], [0.17, 0.22], [0.24, 0.4], [0.3, 0.62], [0.36, 0.8], [0.46, 0.92], [0.55, 1], [0.63, 0.95], [0.72, 0.85], [0.8, 0.6], [0.86, 0.45], [0.92, 0.4], [0.97, 0.16], [1, 0.08]];
const WF_THICK_BOOST = 1.45;
const WF_SLIM_ANCHOR = 0.15;
const WF_WEIGHTS = [1.7, 1.425, 1.18, 0.96, 0.76, 0.59, 0.45, 0.33, 0.225, 0.15]
  .map((w) => WF_SLIM_ANCHOR + (w - WF_SLIM_ANCHOR) * WF_THICK_BOOST);

function wfProf(ty) {
  if (ty <= WF_PROFILE[0][0]) return WF_PROFILE[0][1];
  for (let i = 1; i < WF_PROFILE.length; i++) {
    if (ty <= WF_PROFILE[i][0]) {
      const a = WF_PROFILE[i - 1];
      const b = WF_PROFILE[i];
      return a[1] + (b[1] - a[1]) * ((ty - a[0]) / (b[0] - a[0]));
    }
  }
  return WF_PROFILE[WF_PROFILE.length - 1][1];
}

function wfWarp(pts, t) {
  const amt = 1 - t;
  return pts.map((p) => [WF_CX + (p[0] - WF_CX) * (1 - WF_K * amt * wfProf((p[1] - WF_FY) / WF_FH)), p[1]]);
}

function wfSmooth(pts) {
  const n = pts.length;
  let d = `M ${pts[0][0].toFixed(1)} ${pts[0][1].toFixed(1)} `;
  for (let i = 0; i < n; i++) {
    const p0 = pts[(i - 1 + n) % n];
    const p1 = pts[i];
    const p2 = pts[(i + 1) % n];
    const p3 = pts[(i + 2) % n];
    const c1x = p1[0] + (p2[0] - p0[0]) / 6;
    const c1y = p1[1] + (p2[1] - p0[1]) / 6;
    const c2x = p2[0] - (p3[0] - p1[0]) / 6;
    const c2y = p2[1] - (p3[1] - p1[1]) / 6;
    d += `C ${c1x.toFixed(1)} ${c1y.toFixed(1)}, ${c2x.toFixed(1)} ${c2y.toFixed(1)}, ${p2[0].toFixed(1)} ${p2[1].toFixed(1)} `;
  }
  return `${d}Z`;
}

function wfPoly(pts) {
  return `M ${pts.map((p) => `${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(' L ')} Z`;
}

function createWeightFigure(root) {
  const shape = root.querySelector('.wf-shape');
  const detailGroup = root.querySelector('.wf-detail');
  if (!shape || !detailGroup) return null;

  WF_INTERIOR.forEach(() => {
    detailGroup.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'path'));
  });

  const detailPaths = [...detailGroup.children];
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  let curW = WF_WEIGHTS[0];
  let idx = 0;
  let raf = null;

  function render(t) {
    shape.setAttribute('d', wfSmooth(wfWarp(WF_OUTER, t)));
    WF_INTERIOR.forEach((pts, i) => {
      detailPaths[i].setAttribute('d', wfPoly(wfWarp(pts, t)));
    });
  }

  function setStep(i, opt = {}) {
    i = Math.max(0, Math.min(WF_WEIGHTS.length - 1, i | 0));
    idx = i;
    root.setAttribute('data-step', String(i));

    const to = WF_WEIGHTS[i];
    const from = curW;
    const animate = opt.animate !== false && !reduceMotion;
    const dur = opt.duration || 900;

    if (!animate) {
      curW = to;
      render(to);
      return;
    }

    cancelAnimationFrame(raf);
    const start = performance.now();
    const ease = (x) => (x < 0.5 ? 4 * x * x * x : 1 - ((-2 * x + 2) ** 3) / 2);

    function frame(now) {
      const p = Math.min((now - start) / dur, 1);
      const t = from + (to - from) * ease(p);
      curW = t;
      render(t);
      if (p < 1) raf = requestAnimationFrame(frame);
    }

    raf = requestAnimationFrame(frame);
  }

  const controller = {
    setStep,
    getStep: () => idx,
    count: WF_WEIGHTS.length,
    weights: WF_WEIGHTS
  };

  const init = parseInt(root.getAttribute('data-step') || '0', 10) || 0;
  curW = WF_WEIGHTS[init];
  idx = init;
  render(curW);
  root.setAttribute('data-step', String(idx));
  root.controller = controller;

  return controller;
}

function initWeightFigures() {
  let first = null;

  document.querySelectorAll('.wf:not([data-wf-initialized])').forEach((el) => {
    const controller = createWeightFigure(el);
    if (controller) {
      el.setAttribute('data-wf-initialized', 'true');
      if (!first) first = controller;
    }
  });

  if (first) window.WeightFigure = first;
  window.createWeightFigure = createWeightFigure;
}

function calculateWeightLoss(weightLb) {
  const weight = parseFloat(weightLb);
  if (isNaN(weight) || weight <= 0) return 0;
  return Math.round((weight * WF_REFERENCE_LOSS_LB) / WF_REFERENCE_WEIGHT);
}

function weightToFigureStep(weightLb) {
  const weight = parseFloat(weightLb) || WF_REFERENCE_WEIGHT;
  const step = Math.round(WF_REFERENCE_STEP + (WF_REFERENCE_WEIGHT - weight) / WF_WEIGHT_STEP_SCALE);
  return Math.max(0, Math.min(WF_WEIGHTS.length - 1, step));
}

function personalizedFigureStep(baseStep, tabIndex, tabStepScale) {
  const scale = parseFloat(tabStepScale) || PERSONALIZED_TAB_STEP_SCALE;
  return Math.min(WF_WEIGHTS.length - 1, baseStep + Math.round(tabIndex * scale));
}

function animateCount(element, targetValue, duration) {
  if (!element) return;
  const start = parseFloat(element.textContent) || 0;
  const startTime = performance.now();

  function step(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const eased = 1 - (1 - progress) ** 3;
    const current = Math.round(start + (targetValue - start) * eased);
    element.textContent = String(current);
    if (progress < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

function initWeightCalculator() {
  const sections = document.querySelectorAll('[data-onors-calculator]');
  sections.forEach((section) => {
    const input = section.querySelector('[data-weight-input]');
    const resultEl = section.querySelector('[data-weight-result]');
    const button = section.querySelector('[data-calculator-submit]');

    if (!input || !resultEl) return;

    const unit = section.getAttribute('data-weight-unit') || 'lb';

    function updateResult(weight) {
      const entered = parseFloat(weight);
      const weightLb = unit === 'kg' ? entered / KG_PER_LB : entered;
      const loss = calculateWeightLoss(unit === 'kg' ? entered : weightLb);
      sessionStorage.setItem(ONORS_STORAGE_KEY, JSON.stringify({ weight: weightLb, loss }));

      animateCount(resultEl, loss, 1200);

      document.dispatchEvent(new CustomEvent('onors:weight-calculated', {
        detail: { weight: weightLb, loss }
      }));
    }

    input.addEventListener('input', () => {
      const val = input.value.trim();
      if (val && parseFloat(val) > 0) {
        updateResult(val);
      }
    });

    if (button) {
      button.addEventListener('click', (e) => {
        const val = input.value.trim();
        if (!val || parseFloat(val) <= 0) {
          e.preventDefault();
          input.focus();
          return;
        }
        updateResult(val);
        const target = button.getAttribute('href');
        if (target && target.startsWith('#')) {
          e.preventDefault();
          document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    const saved = sessionStorage.getItem(ONORS_STORAGE_KEY);
    if (saved) {
      try {
        const data = JSON.parse(saved);
        if (data.weight) {
          const displayWeight = unit === 'kg' ? Math.round(data.weight * KG_PER_LB) : data.weight;
          input.value = displayWeight;
          updateResult(displayWeight);
        }
      } catch (e) {}
    } else if (input.value) {
      updateResult(input.value);
    }
  });
}

function initPersonalizedResults() {
  const sections = document.querySelectorAll('[data-onors-personalized]');
  sections.forEach((section) => {
    const figureEl = section.querySelector('[data-weight-figure]');
    const selectors = section.querySelectorAll('[data-personalized-selector]');
    const cards = section.querySelectorAll('[data-personalized-card]');
    const useCalculator = section.getAttribute('data-use-calculator') === 'true';
    const startingFigureStep = Math.max(0, Math.min(WF_WEIGHTS.length - 1, parseInt(section.getAttribute('data-starting-figure-step') || '1', 10) || 1));
    const tabStepScale = section.getAttribute('data-tab-step-scale') || String(PERSONALIZED_TAB_STEP_SCALE);
    let baseStep = startingFigureStep;
    let activeTab = 0;

    function applyFigureStep(tabIndex) {
      if (!figureEl?.controller) return;
      figureEl.controller.setStep(personalizedFigureStep(baseStep, tabIndex, tabStepScale));
    }

    function updateFromWeight(data) {
      if (useCalculator && data?.weight) {
        baseStep = weightToFigureStep(data.weight);
      } else {
        baseStep = startingFigureStep;
      }
      applyFigureStep(activeTab);
    }

    function selectOption(index) {
      activeTab = index;
      selectors.forEach((sel, i) => {
        sel.classList.toggle('is-selected', i === index);
      });
      cards.forEach((card, i) => {
        card.hidden = i !== index;
      });
      applyFigureStep(index);

      const selectedSelector = selectors[index];
      const selectorsWrap = section.querySelector('.bk-media-personalized__selectors-wrap');
      if (selectedSelector && selectorsWrap) {
        const wrapRect = selectorsWrap.getBoundingClientRect();
        const selRect = selectedSelector.getBoundingClientRect();
        const scrollLeft = selectorsWrap.scrollLeft + (selRect.left - wrapRect.left) - (wrapRect.width - selRect.width) / 2;
        selectorsWrap.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }
    }

    selectors.forEach((sel, i) => {
      sel.addEventListener('click', () => selectOption(i));
    });

    selectOption(0);

    if (useCalculator) {
      const saved = sessionStorage.getItem(ONORS_STORAGE_KEY);
      if (saved) {
        try {
          updateFromWeight(JSON.parse(saved));
        } catch (e) {
          updateFromWeight(null);
        }
      } else {
        updateFromWeight(null);
      }

      document.addEventListener('onors:weight-calculated', (e) => {
        updateFromWeight(e.detail);
      });
    } else {
      updateFromWeight(null);
    }
  });
}

function initFooterMenus() {
  const mq = window.matchMedia('(min-width: 700px)');

  function sync() {
    document.querySelectorAll('.bk-media-footer .bk-media-footer__menu details').forEach((details) => {
      if (mq.matches) details.setAttribute('open', '');
      else details.removeAttribute('open');
    });
  }

  sync();
  mq.addEventListener('change', sync);
}

function ensureCountdownHelpers() {
  const H = window.bkMediaAnnouncementCountdownHelpers || (window.bkMediaAnnouncementCountdownHelpers = {});
  if (H.pad && H.computeParts) return H;

  H.pad = (n) => (n < 10 ? '0' : '') + n;
  H.computeParts = (rolling, endDateMs, now) => {
    let days = 0;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    let offerMs = 0;

    if (rolling) {
      const twoDaysMs = 2 * 24 * 60 * 60 * 1000;
      const segmentLength = twoDaysMs / 3;
      const positionInCycle = now % twoDaysMs;
      let remainingMs = 0;

      if (positionInCycle < segmentLength) {
        days = 4;
        remainingMs = segmentLength - positionInCycle;
      } else if (positionInCycle < segmentLength * 2) {
        days = 3;
        remainingMs = (segmentLength * 2) - positionInCycle;
      } else {
        days = 2;
        remainingMs = twoDaysMs - positionInCycle;
      }

      offerMs = remainingMs;
      hours = Math.floor(remainingMs / 3600000);
      minutes = Math.floor((remainingMs % 3600000) / 60000);
      seconds = Math.floor((remainingMs % 60000) / 1000);
    } else if (endDateMs) {
      const distance = endDateMs - now;

      if (distance <= 0) {
        offerMs = 0;
      } else {
        offerMs = distance;
        days = Math.floor(distance / 86400000);
        hours = Math.floor((distance % 86400000) / 3600000);
        minutes = Math.floor((distance % 3600000) / 60000);
        seconds = Math.floor((distance % 60000) / 1000);
      }
    }

    return { rolling: !!rolling, days, hours, minutes, seconds, offerMs };
  };

  return H;
}

function parseCountdownPartsFromRoot(root) {
  if (!root) return null;

  const dEl = root.querySelector('[data-timer-days]');
  const hEl = root.querySelector('[data-timer-hours]');
  const mEl = root.querySelector('[data-timer-minutes]');
  const sEl = root.querySelector('[data-timer-seconds]');

  if (!hEl || !mEl || !sEl) return null;

  let days = dEl ? parseInt(dEl.textContent.trim(), 10) : 0;
  const hours = parseInt(hEl.textContent.trim(), 10);
  const minutes = parseInt(mEl.textContent.trim(), 10);
  const seconds = parseInt(sEl.textContent.trim(), 10);

  if (!isFinite(days)) days = 0;
  if (!isFinite(hours) || !isFinite(minutes) || !isFinite(seconds)) return null;

  return { days, hours, minutes, seconds };
}

function parseCountdownEndDate(endDateStr) {
  if (!endDateStr) return null;

  const normalized = endDateStr.trim().replace(' ', 'T');
  const endDateMs = Date.parse(normalized);

  return Number.isFinite(endDateMs) ? endDateMs : null;
}

function initCountdownSource(H) {
  const source = document.querySelector('[data-onors-countdown-source]');
  if (!source) {
    H.syncOfferTimerSource = null;
    return;
  }

  const endDateMs = parseCountdownEndDate(source.dataset.countdownEnd);
  H.syncOfferTimerSource = endDateMs
    ? { rolling: false, endDateMs }
    : { rolling: true, endDateMs: null };
}

function getCountdownParts(H) {
  if (H.syncOfferTimerSource && typeof H.computeParts === 'function') {
    return H.computeParts(H.syncOfferTimerSource.rolling, H.syncOfferTimerSource.endDateMs, Date.now());
  }

  const externalTimers = document.querySelectorAll('.bk-media-announcement-timer:not([data-offer-countdown])');
  for (const timer of externalTimers) {
    const parts = parseCountdownPartsFromRoot(timer);
    if (parts) return parts;
  }

  const bar = document.getElementById('blackFridayBar');
  if (bar) {
    const nums = bar.querySelectorAll('.timer-box__number');
    if (nums.length >= 4) {
      const days = parseInt(nums[0].textContent.trim(), 10);
      const hours = parseInt(nums[1].textContent.trim(), 10);
      const minutes = parseInt(nums[2].textContent.trim(), 10);
      const seconds = parseInt(nums[3].textContent.trim(), 10);
      if (isFinite(hours) && isFinite(minutes) && isFinite(seconds)) {
        return { days: isFinite(days) ? days : 0, hours, minutes, seconds };
      }
    }
  }

  return H.computeParts(true, null, Date.now());
}

function applyCountdownParts(root, parts) {
  const dEl = root.querySelector('[data-timer-days]');
  const hEl = root.querySelector('[data-timer-hours]');
  const mEl = root.querySelector('[data-timer-minutes]');
  const sEl = root.querySelector('[data-timer-seconds]');

  if (dEl) dEl.textContent = parts.days < 0 ? '0' : parts.days;
  if (hEl) hEl.textContent = parts.hours < 0 ? '0' : parts.hours;
  if (mEl) mEl.textContent = parts.minutes < 0 ? '0' : parts.minutes;
  if (sEl) sEl.textContent = parts.seconds < 0 ? '0' : parts.seconds;
}

function initOfferCountdowns() {
  const timers = document.querySelectorAll('.bk-media-announcement-timer[data-offer-countdown]');
  if (!timers.length) return;

  const H = ensureCountdownHelpers();
  initCountdownSource(H);

  timers.forEach((timer) => {
    if (timer.dataset.countdownInitialized === 'true') return;
    timer.dataset.countdownInitialized = 'true';

    const tick = () => {
      applyCountdownParts(timer, getCountdownParts(H));
    };

    tick();
    const intervalId = window.setInterval(tick, 1000);
    timer.dataset.countdownIntervalId = String(intervalId);
  });
}

const ONORS_SKIP_TOP_AREA_SECTIONS = [
  'shopify-section--lp-template-settings',
  'shopify-section--header-group-settings',
  'shopify-section--lp-logo-header'
];

function isTransparentColor(color) {
  return !color || color === 'transparent' || color === 'rgba(0, 0, 0, 0)';
}

function colorFromBackgroundVar(element) {
  if (!element) return null;

  const triplet = getComputedStyle(element).getPropertyValue('--background').trim();
  if (!/^\d+\s+\d+\s+\d+/.test(triplet)) return null;

  const parts = triplet.split(/\s+/).slice(0, 3).map(Number);
  if (parts.some((value) => Number.isNaN(value))) return null;

  return `rgb(${parts[0]}, ${parts[1]}, ${parts[2]})`;
}

function readElementBackground(element) {
  if (!element) return null;

  const fromVar = colorFromBackgroundVar(element);
  if (fromVar) return fromVar;

  const backgroundColor = getComputedStyle(element).backgroundColor;
  if (!isTransparentColor(backgroundColor)) return backgroundColor;

  return null;
}

function getFirstMainSection() {
  const main = document.getElementById('main');
  if (!main) return null;

  return [...main.querySelectorAll(':scope > .shopify-section')].find((section) => {
    if (ONORS_SKIP_TOP_AREA_SECTIONS.some((className) => section.classList.contains(className))) return false;

    const style = getComputedStyle(section);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (section.offsetHeight === 0) return false;

    return true;
  }) || null;
}

function getSectionTopBackground(section) {
  const candidates = [
    section,
    section.querySelector('.lp-hero'),
    section.querySelector('.section.bg-custom'),
    section.querySelector('.section'),
    section.querySelector('[class^="lp-"]'),
    section.firstElementChild
  ].filter(Boolean);

  const seen = new Set();

  for (const element of candidates) {
    if (seen.has(element)) continue;
    seen.add(element);

    const background = readElementBackground(element);
    if (background) return background;
  }

  return null;
}

class BkMediaReviewsOrbit extends HTMLElement {
  connectedCallback() {
    this._desktopQuery = window.matchMedia('(min-width: 700px)');
    this._onViewportChange = () => this._boot(true);
    this._desktopQuery.addEventListener('change', this._onViewportChange);
    requestAnimationFrame(() => this._boot(false));
  }

  disconnectedCallback() {
    this._stop();
    this._resizeObserver?.disconnect();
    this._resizeObserver = null;
    this._desktopQuery?.removeEventListener('change', this._onViewportChange);
  }

  _stop() {
    if (this._rafId) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }

    this._running = false;
  }

  _isDesktop() {
    return this._desktopQuery.matches;
  }

  _getMaxItems() {
    const value = parseInt(this._isDesktop() ? this.dataset.maxItemsDesktop : this.dataset.maxItemsMobile, 10);
    return Number.isFinite(value) && value > 0 ? value : (this._isDesktop() ? 10 : 6);
  }

  _collectItems() {
    const maxItems = this._getMaxItems();
    const allItems = [...this.querySelectorAll('[data-orbit-item]')];

    allItems.forEach((item, index) => {
      const active = index < maxItems;
      item.hidden = !active;
    });

    return allItems.slice(0, maxItems);
  }

  _syncCardWidth() {
    const stage = this.closest('.bk-media-reviews-widget__stage');
    const count = Math.max(this.items?.length || 1, 3);
    const stageWidth = stage?.clientWidth || window.innerWidth;
    const gap = this._isDesktop() ? 18 : 12;
    const sin = Math.sin(Math.PI / count) || 1;
    const halfLimit = stageWidth / 2 - 10;
    const coeff = 1 / (2 * sin) + 0.5;
    const gapTerm = gap / (2 * sin);
    let width = (halfLimit - gapTerm) / coeff;
    const min = this._isDesktop() ? 132 : 120;
    const max = this._isDesktop() ? 196 : 168;

    if (!this._isDesktop()) width *= 1.15;

    width = Math.max(min, Math.min(max, width));
    this.style.setProperty('--bk-media-reviews-card-width', `${Math.round(width)}px`);
  }

  _spacingRadius() {
    const count = Math.max(this.items?.length || 1, 3);
    const gap = this._isDesktop() ? 18 : 12;
    const sin = Math.sin(Math.PI / count) || 1;
    let extent = 0;

    const overlap = this._isDesktop() ? 0 : 48;

    this.items?.forEach((item) => {
      const card = item.querySelector('[data-orbit-card]');
      if (!card) return;
      extent = Math.max(extent, card.offsetWidth, card.offsetHeight - overlap);
    });

    if (!extent) extent = this._isDesktop() ? 160 : 120;

    return (extent + gap) / (2 * sin);
  }

  _dialog() {
    return this.closest('.bk-media-reviews-widget')?.querySelector('[data-reviews-dialog]');
  }

  _bindDialog() {
    const dialog = this._dialog();
    if (!dialog || this._dialogBound) return;

    this._dialogBound = true;
    dialog.addEventListener('close', () => {
      this._dialogOpen = false;
      this._openCard?.classList.remove('is-open');
      this._openCard = null;
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.querySelector('[data-reviews-dialog-close]')?.addEventListener('click', () => dialog.close());
  }

  _openReview(card) {
    const dialog = this._dialog();
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const text = card.querySelector('[data-review-text]')?.textContent?.trim() || '';
    const author = card.querySelector('[data-review-author]')?.textContent?.trim() || '';
    const textEl = dialog.querySelector('[data-reviews-dialog-text]');
    const authorEl = dialog.querySelector('[data-reviews-dialog-author]');

    if (textEl) textEl.textContent = text;
    if (authorEl) {
      authorEl.textContent = author;
      authorEl.hidden = author === '';
    }

    this._openCard?.classList.remove('is-open');
    card.classList.add('is-open');
    this._openCard = card;
    this._dialogOpen = true;

    if (!dialog.open) dialog.showModal();
  }

  _getCircleAngles(total) {
    const step = 360 / total;
    const angles = [];

    for (let i = 0; i < total; i++) {
      angles.push(step * i);
    }

    return angles;
  }

  _getProductClearanceAtAngle(deg, halfWidth, halfHeight) {
    const rad = (deg * Math.PI) / 180;
    const x = Math.sin(rad);
    const y = -Math.cos(rad);
    let distance = Infinity;

    if (x !== 0) distance = Math.min(distance, halfWidth / Math.abs(x));
    if (y !== 0) distance = Math.min(distance, halfHeight / Math.abs(y));

    return Number.isFinite(distance) ? distance : Math.max(halfWidth, halfHeight);
  }

  _measureOrbit() {
    this._syncCardWidth();

    const gap = parseFloat(this._isDesktop() ? this.dataset.orbitGapDesktop : this.dataset.orbitGapMobile) || 48;
    const spread = parseFloat(this._isDesktop() ? this.dataset.orbitSpreadDesktop : this.dataset.orbitSpreadMobile) || 0;
    const influence = (parseFloat(this._isDesktop() ? this.dataset.orbitInfluenceDesktop : this.dataset.orbitInfluenceMobile) || 50) / 100;
    this.rotationSpeed = parseFloat(this._isDesktop() ? this.dataset.rotationSpeedDesktop : this.dataset.rotationSpeedMobile) || (this._isDesktop() ? 4 : 1);

    const core = this.closest('.bk-media-reviews-widget__stage-inner');
    const product = core?.querySelector('.bk-media-reviews-widget__product-image, .bk-media-reviews-widget__product-placeholder');
    const baselineHalf = parseFloat(this._isDesktop() ? this.dataset.orbitBaselineDesktop : this.dataset.orbitBaselineMobile) || (this._isDesktop() ? 160 : 104);

    if (product && product.offsetWidth > 0) {
      const halfWidth = product.offsetWidth / 2;
      const halfHeight = (product.offsetHeight || product.offsetWidth) / 2;
      const angles = this._itemBaseAngles?.length ? this._itemBaseAngles : this._getItemBaseAngles(this.items?.length || 4);
      let maxClearance = 0;

      angles.forEach((angle) => {
        maxClearance = Math.max(maxClearance, this._getProductClearanceAtAngle(angle, halfWidth, halfHeight));
      });

      const productHalf = halfWidth;
      const effectiveHalf = productHalf <= baselineHalf
        ? productHalf
        : baselineHalf + (productHalf - baselineHalf) * influence;

      this.orbitRadius = Math.max(maxClearance, effectiveHalf) + gap + spread;
    } else {
      this.orbitRadius = baselineHalf + gap + spread;
    }

    const stage = core?.closest('.bk-media-reviews-widget__stage');
    const spacingRadius = this._spacingRadius();

    this.orbitRadius = Math.max(this.orbitRadius, spacingRadius, gap + spread + 72);

    if (stage && stage.clientWidth > 0) {
      const cardHalf = this._isDesktop() ? this._getCardHalf() : this._getCardWidthHalf();
      const maxRadius = stage.clientWidth / 2 - cardHalf - 6 + spread;

      if (maxRadius > 72) {
        this.orbitRadius = Math.min(this.orbitRadius, maxRadius);
      }
    }

    this._updateStageSize(core);
  }

  _getCardHalf() {
    const card = this.items?.[0]?.querySelector('[data-orbit-card]');
    if (!card || !card.offsetWidth) return this._isDesktop() ? 72 : 56;

    return Math.max(card.offsetWidth, card.offsetHeight) / 2;
  }

  _getCardWidthHalf() {
    const card = this.items?.[0]?.querySelector('[data-orbit-card]');
    if (!card || !card.offsetWidth) return 56;

    return card.offsetWidth / 2;
  }

  _updateStageSize(core) {
    if (!core) return;

    const stageSize = (this.orbitRadius + this._getCardHalf()) * 2;
    core.style.setProperty('--bk-media-reviews-stage-size', `${stageSize}px`);
  }

  _boot(force = false) {
    if (this._running && !force) return;

    this._stop();
    this.items = this._collectItems();
    this.rotationEnabled = this.dataset.rotation !== 'false';
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.isDesignMode = window.Shopify?.designMode === true;
    this.baseAngle = this.baseAngle || 0;
    this._hovering = false;
    this._lastTime = performance.now();
    this._bindDialog();
    this._dialogOpen = Boolean(this._dialog()?.open);

    if (!this._listenersBound) {
      this._listenersBound = true;
      this.addEventListener('mouseenter', () => {
        this._hovering = true;
      });
      this.addEventListener('mouseleave', () => {
        this._hovering = false;
      });
      this.addEventListener('click', (event) => {
        const card = event.target.closest('[data-orbit-card]');
        if (!card || card.closest('[hidden]')) return;
        this._openReview(card);
      });
    }

    if (!this.items.length) {
      this._resetItems();
      return;
    }

    const core = this.closest('.bk-media-reviews-widget__stage-inner');

    this._itemBaseAngles = this._getItemBaseAngles(this.items.length);
    this._measureOrbit();
    this._bindResizeObserver();
    this._watchProductImage(core);

    this._running = true;
    this._applyTransforms();
    this._rafId = requestAnimationFrame((time) => {
      this._lastTime = time;
      this._tick(time);
    });
  }

  _bindResizeObserver() {
    const core = this.closest('.bk-media-reviews-widget__stage-inner');
    if (!core || this._resizeObserver) return;

    this._resizeObserver = new ResizeObserver(() => {
      this._measureOrbit();
      this._applyTransforms();
    });

    this._resizeObserver.observe(core);

    const stage = core.closest('.bk-media-reviews-widget__stage');
    const product = core.querySelector('.bk-media-reviews-widget__product-image, .bk-media-reviews-widget__product-placeholder');

    if (stage) this._resizeObserver.observe(stage);
    if (product) this._resizeObserver.observe(product);
  }

  _watchProductImage(core) {
    const product = core?.querySelector('.bk-media-reviews-widget__product-image, .bk-media-reviews-widget__product-placeholder');

    if (!product) return;

    const remeasure = () => {
      this._measureOrbit();
      this._applyTransforms();
    };

    if (!product.complete) {
      product.addEventListener('load', remeasure, { once: true });
    }

    if (product.tagName === 'IMG' && product.decode) {
      product.decode().then(remeasure).catch(() => {});
    }
  }

  _getItemBaseAngles(total) {
    if (!total) return [];

    return this._getCircleAngles(total);
  }

  _resetItems() {
    this.querySelectorAll('[data-orbit-item]').forEach((item) => {
      item.hidden = false;
      item.style.transform = '';
      item.style.zIndex = '';

      const card = item.querySelector('[data-orbit-card]');
      if (card) card.style.transform = 'translate(-50%, -50%)';
    });
  }

  _applyTransforms() {
    if (!this.items?.length || !this.orbitRadius) return;

    this.items.forEach((item, index) => {
      const angle = this.baseAngle + this._itemBaseAngles[index];
      item.style.transform = `rotate(${angle}deg) translateY(-${this.orbitRadius}px)`;

      const card = item.querySelector('[data-orbit-card]');
      if (card) card.style.transform = `translate(-50%, -50%) rotate(${-angle}deg)`;

      const open = card?.classList.contains('is-open');
      item.style.zIndex = open ? '400' : String(Math.round(100 + Math.cos(((angle - 90) * Math.PI) / 180) * 50));
    });
  }

  _tick(time) {
    if (!this._running) return;

    const dt = Math.min((time - this._lastTime) / 1000, 0.05);
    this._lastTime = time;

    const hoverPaused = this._hovering && !this.isDesignMode;

    if (this.rotationEnabled && !this.reducedMotion && !this._dialogOpen && !hoverPaused) {
      this.baseAngle += this.rotationSpeed * dt;

      if (this.baseAngle >= 360) {
        this.baseAngle -= 360;
      }
    }

    this._applyTransforms();
    this._rafId = requestAnimationFrame((nextTime) => this._tick(nextTime));
  }
}

if (!window.customElements.get('bk-media-reviews-orbit')) {
  window.customElements.define('bk-media-reviews-orbit', BkMediaReviewsOrbit);
}

function initReviewsOrbit() {
  document.querySelectorAll('bk-media-reviews-orbit').forEach((orbit) => {
    if (typeof orbit._boot === 'function') orbit._boot(true);
  });
}

function initReviewsRead() {
  document.querySelectorAll('.bk-media-reviews-widget').forEach((widget) => {
    if (widget.dataset.reviewsReadReady === 'true') return;

    const dialog = widget.querySelector('[data-reviews-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    widget.dataset.reviewsReadReady = 'true';

    const textEl = dialog.querySelector('[data-reviews-dialog-text]');
    const authorEl = dialog.querySelector('[data-reviews-dialog-author]');
    const marquee = widget.querySelector('.bk-media-reviews-widget__marquee');

    dialog.addEventListener('close', () => {
      marquee?.classList.remove('is-paused');
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.querySelector('[data-reviews-dialog-close]')?.addEventListener('click', () => dialog.close());

    widget.addEventListener('click', (event) => {
      const card = event.target.closest('[data-review-card]');
      if (!card || !widget.contains(card)) return;

      const text = card.querySelector('[data-review-text]')?.textContent?.trim() || '';
      const author = card.querySelector('[data-review-author]')?.textContent?.trim() || '';

      if (textEl) textEl.textContent = text;
      if (authorEl) {
        authorEl.textContent = author;
        authorEl.hidden = author === '';
      }

      marquee?.classList.add('is-paused');
      if (!dialog.open) dialog.showModal();
    });
  });
}

function initBeforeAfterAutoplay() {
  document.querySelectorAll('[data-before-after-autoplay]').forEach((wrapper) => {
    if (wrapper._beforeAfterAutoplayCleanup) {
      wrapper._beforeAfterAutoplayCleanup();
      wrapper._beforeAfterAutoplayCleanup = null;
    }

    wrapper._beforeAfterAutoplayCleanup = setupBeforeAfterAutoplay(wrapper);
  });
}

function setupBeforeAfterAutoplay(wrapper) {
  const carousel = wrapper.querySelector('scroll-carousel');
  if (!carousel || carousel.items.length <= 1) return () => {};

  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return () => {};

  const interval = parseInt(wrapper.getAttribute('data-before-after-interval') || '3000', 10);
  let paused = false;
  let timer = null;

  const tick = () => {
    if (paused) return;

    const total = carousel.items.length;
    const nextIndex = carousel.selectedIndex >= total - 1 ? 0 : carousel.selectedIndex + 1;
    carousel.select(nextIndex);
  };

  const stop = () => {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  };

  const start = () => {
    stop();
    timer = setInterval(tick, interval);
  };

  const pause = () => {
    paused = true;
  };

  const resume = () => {
    paused = false;
  };

  const onVisibilityChange = () => {
    if (document.hidden) pause();
    else resume();
  };

  wrapper.addEventListener('mouseenter', pause);
  wrapper.addEventListener('mouseleave', resume);
  wrapper.addEventListener('focusin', pause);
  wrapper.addEventListener('focusout', resume);
  document.addEventListener('visibilitychange', onVisibilityChange);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) resume();
      else pause();
    });
  }, { threshold: 0.25 });

  observer.observe(wrapper);
  start();

  return () => {
    stop();
    observer.disconnect();
    wrapper.removeEventListener('mouseenter', pause);
    wrapper.removeEventListener('mouseleave', resume);
    wrapper.removeEventListener('focusin', pause);
    wrapper.removeEventListener('focusout', resume);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
}

function initOnorsTopAreaBackground() {
  const section = getFirstMainSection();
  const background = section ? getSectionTopBackground(section) : null;

  if (!background) return;

  document.documentElement.style.setProperty('--onors-top-area-section-bg', background);
}

function init90TageKur() {
  const TOTAL = 90;
  const BARS = 48;

  document.querySelectorAll('[data-bk-media-90-tage]:not([data-bk-media-90-tage-initialized])').forEach((card) => {
    const configScript = card.querySelector('[data-bk-media-90-tage-config]');
    if (!configScript) return;

    let config;
    try {
      config = JSON.parse(configScript.textContent);
    } catch (error) {
      console.error('Failed to parse 90-Tage-Kur config:', error);
      return;
    }

    const barsEl = card.querySelector('[data-bk-media-90-tage-bars]');
    const markerEl = card.querySelector('[data-bk-media-90-tage-marker]');
    const markerDayEl = card.querySelector('[data-bk-media-90-tage-marker-day]');
    const calloutEl = card.querySelector('[data-bk-media-90-tage-callout]');
    const pctValueEl = card.querySelector('[data-bk-media-90-tage-pct-value]');
    const pctLabelEl = card.querySelector('[data-bk-media-90-tage-pct-label]');
    const trackEl = card.querySelector('[data-bk-media-90-tage-track]');
    const footEl = card.querySelector('[data-bk-media-90-tage-foot]');

    if (!barsEl || !markerEl || !markerDayEl || !trackEl || !footEl) return;

    const milestones = Array.isArray(config.milestones) ? config.milestones : [];
    const nodes = [];
    let currentIndex = -1;
    let timer = null;

    function updateProgress(milestone) {
      if (!milestone) return;

      const day = Math.min(Math.max(Number(milestone.day) || 0, 0), TOTAL);
      const position = (day / TOTAL) * 100;
      const onCount = Math.round(BARS * (day / TOTAL));

      barsEl.innerHTML = Array.from({ length: BARS }, (_, index) => {
        return `<div class="bk-media-90-tage__bar${index < onCount ? ' is-on' : ''}"></div>`;
      }).join('');

      markerEl.style.left = `${position}%`;
      markerDayEl.textContent = String(day);

      if (pctValueEl) pctValueEl.textContent = milestone.percentage || `${Math.round(position)}%`;
      if (pctLabelEl) pctLabelEl.textContent = milestone.percentageLabel || '';

      if (calloutEl) {
        const showCallout = Boolean(milestone.showCallout);
        calloutEl.hidden = !showCallout;
        calloutEl.classList.toggle('bk-media-90-tage__callout--hidden', !showCallout);
        calloutEl.style.left = `${position}%`;
      }
    }

    trackEl.innerHTML = '';

    milestones.forEach((milestone, index) => {
      const node = document.createElement('div');
      node.className = 'bk-media-90-tage__node';
      node.style.left = `${(milestone.day / TOTAL) * 100}%`;
      node.setAttribute('data-align', milestone.align || 'center');
      node.innerHTML =
        `<div class="bk-media-90-tage__lbl" role="button" tabindex="0" aria-label="Phase ${milestone.name}, Day ${milestone.day}">` +
        `<strong>${milestone.name}</strong><em>Day ${milestone.day}</em></div>`;
      trackEl.appendChild(node);
      nodes.push(node);

      const activate = () => {
        show(index);
        restart();
      };

      node.addEventListener('click', activate);
      node.querySelector('.bk-media-90-tage__lbl').addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate();
        }
      });
    });

    function show(index) {
      if (index === currentIndex || !milestones[index]) return;
      currentIndex = index;
      const milestone = milestones[index];

      nodes.forEach((node, nodeIndex) => {
        node.classList.toggle('is-active', nodeIndex === index);
      });

      updateProgress(milestone);

      footEl.style.opacity = '0';
      window.setTimeout(() => {
        footEl.innerHTML = milestone.text || '';
        footEl.style.opacity = '1';
      }, 180);
    }

    function next() {
      show((currentIndex + 1) % milestones.length);
    }

    function restart() {
      stop();
      timer = window.setInterval(next, 3000);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    card.addEventListener('mouseenter', stop);
    card.addEventListener('mouseleave', restart);
    card.addEventListener('focusin', stop);
    card.addEventListener('focusout', restart);
    card.setAttribute('data-bk-media-90-tage-initialized', 'true');

    if (milestones.length > 0) {
      show(0);
      restart();
    }
  });
}

function initTimerBlock(timerElement) {
  const daysEl = timerElement.querySelector('.bk-media-timer-block__timer-days');
  const hoursEl = timerElement.querySelector('.bk-media-timer-block__timer-hours');
  const minutesEl = timerElement.querySelector('.bk-media-timer-block__timer-minutes');
  const secondsEl = timerElement.querySelector('.bk-media-timer-block__timer-seconds');
  const timerBlock = timerElement.closest('.bk-media-timer-block');
  const progressBarFill = timerBlock ? timerBlock.querySelector('.bk-media-timer-block__progress-bar-fill') : null;

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
    return;
  }

  const metaobjectDate = (timerElement.getAttribute('data-metaobject-date') || '').trim();
  const metaobjectStartDate = (timerElement.getAttribute('data-metaobject-start-date') || '').trim();

  function parseDateToTimestamp(dateString) {
    if (!dateString) return null;
    const trimmed = dateString.trim();
    if (!trimmed) return null;

    const numeric = parseInt(trimmed, 10);
    if (!Number.isNaN(numeric) && numeric > 0) {
      return numeric < 10000000000 ? numeric * 1000 : numeric;
    }

    const parsed = new Date(trimmed);
    if (!Number.isNaN(parsed.getTime())) return parsed.getTime();

    return null;
  }

  if (!metaobjectDate) return;

  const endTime = parseDateToTimestamp(metaobjectDate);
  if (endTime == null) return;

  function updateTimer() {
    const now = Date.now();
    let remaining = Math.max(0, Math.floor((endTime - now) / 1000));

    const days = Math.floor(remaining / 86400);
    remaining %= 86400;
    const hours = Math.floor(remaining / 3600);
    remaining %= 3600;
    const mins = Math.floor(remaining / 60);
    const secs = remaining % 60;

    daysEl.textContent = days;
    hoursEl.textContent = hours;
    minutesEl.textContent = mins;
    secondsEl.textContent = secs;

    if (!progressBarFill || !metaobjectStartDate) return;

    const parsedStartDate = parseDateToTimestamp(metaobjectStartDate);
    if (parsedStartDate === null) return;

    const totalDurationSeconds = Math.floor((endTime - parsedStartDate) / 1000);
    if (totalDurationSeconds <= 0) return;

    const elapsedSeconds = Math.max(0, Math.floor((now - parsedStartDate) / 1000));
    const remainingSeconds = Math.max(0, totalDurationSeconds - elapsedSeconds);
    const progress = elapsedSeconds <= totalDurationSeconds
      ? (remainingSeconds / totalDurationSeconds) * 100
      : 0;

    progressBarFill.style.width = `${Math.min(100, Math.max(0, progress))}%`;
  }

  updateTimer();
  timerElement.dataset.intervalId = String(window.setInterval(updateTimer, 1000));
}

function initTimerBlocks() {
  document.querySelectorAll('.bk-media-timer-block__timer').forEach((timer) => {
    const existingIntervalId = timer.dataset.intervalId;
    if (existingIntervalId) {
      window.clearInterval(parseInt(existingIntervalId, 10));
      delete timer.dataset.intervalId;
    }

    timer.dataset.initialized = 'true';
    try {
      initTimerBlock(timer);
    } catch (error) {
      console.error('Error initializing timer block:', error, timer);
      timer.dataset.initialized = 'false';
    }
  });
}

function initTimerCopyButtons() {
  document.querySelectorAll('.bk-media-timer-block__code-badge').forEach((button) => {
    if (button.dataset.copyInitialized) return;
    button.dataset.copyInitialized = 'true';

    button.addEventListener('click', function () {
      const code = this.dataset.code;
      if (!code) return;

      const textEl = this.querySelector('.bk-media-timer-block__code-text');
      const originalText = textEl ? textEl.textContent : '';
      const originalBadgeText = this.textContent;

      const showCopied = () => {
        if (textEl) {
          textEl.textContent = 'Copied!';
        } else {
          this.textContent = 'CODE: Copied!';
        }

        window.setTimeout(() => {
          if (textEl) {
            textEl.textContent = originalText;
          } else {
            this.textContent = originalBadgeText;
          }
        }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch((err) => {
          console.error('Failed to copy code:', err);
        });
        return;
      }

      const textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
        showCopied();
      } catch (err) {
        console.error('Failed to copy code:', err);
      } finally {
        document.body.removeChild(textArea);
      }
    });
  });
}

function stockZonedParts(ms, timeZone) {
  const parts = {};
  new Intl.DateTimeFormat('en-US', {
    timeZone,
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(new Date(ms)).forEach((part) => {
    if (part.type !== 'literal') parts[part.type] = part.value;
  });
  return parts;
}

function stockZonedTimeToUnix(year, month, day, hour, minute, timeZone) {
  let guess = Date.UTC(year, month - 1, day, hour, minute, 0);
  const target = Date.UTC(year, month - 1, day, hour, minute, 0);

  for (let i = 0; i < 4; i += 1) {
    const parts = stockZonedParts(guess, timeZone);
    const asUtc = Date.UTC(
      parseInt(parts.year, 10),
      parseInt(parts.month, 10) - 1,
      parseInt(parts.day, 10),
      parseInt(parts.hour, 10),
      parseInt(parts.minute, 10),
      parseInt(parts.second || '0', 10)
    );
    guess += target - asUtc;
  }

  return Math.floor(guess / 1000);
}

function stockSundayNineUnix(endUnix) {
  const parts = stockZonedParts(endUnix * 1000, 'Europe/Berlin');
  const weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const dow = weekdayMap[parts.weekday] ?? 0;
  const endDayUtc = Date.UTC(
    parseInt(parts.year, 10),
    parseInt(parts.month, 10) - 1,
    parseInt(parts.day, 10)
  );
  const sunday = new Date(endDayUtc - dow * 86400000);
  const anchor = stockZonedTimeToUnix(
    sunday.getUTCFullYear(),
    sunday.getUTCMonth() + 1,
    sunday.getUTCDate(),
    9,
    0,
    'Europe/Berlin'
  );

  if (anchor < endUnix) return anchor;
  return Math.max(0, endUnix - 15 * 3600);
}

function scheduledStockBoxes(pill) {
  const total = parseInt(pill.dataset.stockTotal, 10) || 0;
  const end = parseInt(pill.dataset.stockEnd, 10) || 0;
  const now = Math.floor(Date.now() / 1000);
  const start = stockSundayNineUnix(end);

  if (!total) return 0;
  if (end && now >= end) return 0;
  if (!end || end <= start) return total;

  const raw = total * (end - now) / (end - start);
  return Math.max(0, Math.round(raw));
}

function paintStockPill(pill, count, barMax) {
  const countEl = pill.querySelector('[data-stock-count]');
  const fill = pill.querySelector('[data-stock-fill]');
  const safe = Math.max(0, count);
  const max = barMax || parseInt(pill.dataset.stockTotal, 10) || 0;

  if (countEl) countEl.textContent = String(safe);
  if (fill) fill.style.width = max ? `${Math.min(100, (safe / max) * 100)}%` : '0%';
}

function initStockPills() {
  document.querySelectorAll('.onors-stock-pill').forEach((pill) => {
    if (pill.dataset.stockReady === 'true') return;
    pill.dataset.stockReady = 'true';

    const barMax = Math.max(
      parseInt(pill.dataset.stockTotal, 10) || 0,
      scheduledStockBoxes(pill)
    );

    const tick = () => {
      paintStockPill(pill, scheduledStockBoxes(pill), barMax);
    };

    tick();
    const intervalId = window.setInterval(tick, 30000);
    pill.dataset.stockIntervalId = String(intervalId);
  });
}

function initializeTimerBlocks() {
  initTimerBlocks();
  initTimerCopyButtons();
  initStockPills();
}

function initOnors() {
  initOnorsTopAreaBackground();
  initWeightFigures();
  initWeightCalculator();
  initPersonalizedResults();
  initFooterMenus();
  initOfferCountdowns();
  initBeforeAfterAutoplay();
  initReviewsOrbit();
  initReviewsRead();
  init90TageKur();
  initializeTimerBlocks();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOnors, { once: true });
} else {
  initOnors();
}

document.addEventListener('shopify:section:load', initOnors);
document.addEventListener('product:rerender', () => {
  window.setTimeout(initializeTimerBlocks, 100);
  window.setTimeout(initBkMediaImageComparisons, 100);
});

/* ========================================
   BK-MEDIA IMAGE COMPARISON
   ======================================== */

class BkMediaImageComparison extends HTMLElement {
  connectedCallback() {
    this._onPointerDown = this._onPointerDown.bind(this);
    this._onPointerMove = this._onPointerMove.bind(this);
    this._onPointerUp = this._onPointerUp.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onMouseEnter = this._onMouseEnter.bind(this);
    this._onMouseLeave = this._onMouseLeave.bind(this);
    this._onVisibility = this._onVisibility.bind(this);
    this._tick = this._tick.bind(this);
    this._onDragStart = (event) => event.preventDefault();
    this._onClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    this._setup();
    this._bootRaf = requestAnimationFrame(() => this._setup());
  }

  disconnectedCallback() {
    cancelAnimationFrame(this._bootRaf);
    this._stopAutoplay();
    clearTimeout(this.resumeTimeout);
    this._teardown();
  }

  _setup() {
    if (this._ready) return;

    this.mediaEl = this.querySelector('.bk-media-image-comparison__media');
    this.handleEl = this.querySelector('.bk-media-image-comparison__handle');
    if (!this.mediaEl || !this.handleEl) return;

    let min = parseFloat(this.dataset.min || '20');
    let max = parseFloat(this.dataset.max || '80');
    if (Number.isNaN(min)) min = 20;
    if (Number.isNaN(max)) max = 80;
    min = Math.min(100, Math.max(0, min));
    max = Math.min(100, Math.max(0, max));
    if (min > max) {
      const swap = min;
      min = max;
      max = swap;
    }
    if (min === max) {
      max = Math.min(100, min + 1);
      min = Math.max(0, max - 1);
    }

    this.min = min;
    this.max = max;
    this.duration = Math.max(1.5, parseFloat(this.dataset.duration || '4')) * 1000;
    this.position = this.min;
    this.direction = 1;
    this.dragging = false;
    this.hovering = false;
    this.resumeTimeout = null;
    this.resumeDelay = 5000;
    this.autoplayRaf = null;
    this.lastTs = 0;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this._ready = true;

    this.setPosition(this.position);

    this.isThumb = this.hasAttribute('data-thumb') || this.classList.contains('bk-media-image-comparison--thumb');
    this.inCarousel = Boolean(this.closest('media-carousel'));

    if (!this.isThumb) {
      this.mediaEl.addEventListener('pointerdown', this._onPointerDown);
      this.mediaEl.addEventListener('mouseenter', this._onMouseEnter);
      this.mediaEl.addEventListener('mouseleave', this._onMouseLeave);
      this.mediaEl.addEventListener('click', this._onClick, true);
      this.mediaEl.addEventListener('dragstart', this._onDragStart, true);
      window.addEventListener('pointermove', this._onPointerMove, { passive: false });
      window.addEventListener('pointerup', this._onPointerUp);
      window.addEventListener('pointercancel', this._onPointerUp);
      this.handleEl.addEventListener('keydown', this._onKeyDown);
    }

    document.addEventListener('visibilitychange', this._onVisibility);
    this.setAttribute('data-bk-comparison-ready', 'true');

    this._startAutoplay();
  }

  _teardown() {
    if (!this._ready) return;
    this._stopAutoplay();
    if (!this.isThumb) {
      this.mediaEl?.removeEventListener('pointerdown', this._onPointerDown);
      this.mediaEl?.removeEventListener('mouseenter', this._onMouseEnter);
      this.mediaEl?.removeEventListener('mouseleave', this._onMouseLeave);
      this.mediaEl?.removeEventListener('click', this._onClick, true);
      this.mediaEl?.removeEventListener('dragstart', this._onDragStart, true);
      window.removeEventListener('pointermove', this._onPointerMove);
      window.removeEventListener('pointerup', this._onPointerUp);
      window.removeEventListener('pointercancel', this._onPointerUp);
      this.handleEl?.removeEventListener('keydown', this._onKeyDown);
    }
    document.removeEventListener('visibilitychange', this._onVisibility);
    this._ready = false;
    this.removeAttribute('data-bk-comparison-ready');
  }

  setPosition(value) {
    this.position = Math.min(this.max, Math.max(this.min, value));
    this.style.setProperty('--bk-comparison-position', `${this.position}%`);
    this.handleEl?.setAttribute('aria-valuenow', String(Math.round(this.position)));
  }

  _pointerPercent(clientX) {
    const rect = this.mediaEl.getBoundingClientRect();
    if (!rect.width) return this.position;
    return ((clientX - rect.left) / rect.width) * 100;
  }

  _startAutoplay() {
    if (this.reduceMotion || this.dragging || this.hovering || document.hidden) return;
    if (this.autoplayRaf) return;
    this.lastTs = 0;
    this.autoplayRaf = requestAnimationFrame(this._tick);
  }

  _stopAutoplay() {
    if (this.autoplayRaf) {
      cancelAnimationFrame(this.autoplayRaf);
      this.autoplayRaf = null;
    }
    this.lastTs = 0;
  }

  _tick(ts) {
    if (!this.lastTs) this.lastTs = ts;
    const delta = ts - this.lastTs;
    this.lastTs = ts;

    const range = this.max - this.min;
    const step = (range / this.duration) * delta * this.direction;
    let next = this.position + step;

    if (next >= this.max) {
      next = this.max;
      this.direction = -1;
    } else if (next <= this.min) {
      next = this.min;
      this.direction = 1;
    }

    this.setPosition(next);
    this.autoplayRaf = requestAnimationFrame(this._tick);
  }

  _pauseInteraction() {
    clearTimeout(this.resumeTimeout);
    this._stopAutoplay();
  }

  _scheduleResume() {
    clearTimeout(this.resumeTimeout);
    if (this.dragging || this.hovering) return;

    this.resumeTimeout = setTimeout(() => {
      if (this.dragging || this.hovering) return;
      this._startAutoplay();
    }, this.resumeDelay);
  }

  _onVisibility() {
    if (document.hidden) {
      this._stopAutoplay();
      return;
    }
    if (!this.dragging && !this.hovering) {
      this._startAutoplay();
    }
  }

  _onMouseEnter() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    this.hovering = true;
    this._pauseInteraction();
  }

  _onMouseLeave() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    this.hovering = false;
    if (this.dragging) return;
    this._scheduleResume();
  }

  _onPointerDown(event) {
    if (!this._ready) return;
    if (event.button != null && event.button !== 0) return;
    if (event.target.closest('a')) return;
    if (this.inCarousel && !event.target.closest('.bk-media-image-comparison__handle')) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.dragging = true;
    this._pauseInteraction();
    this.mediaEl.setPointerCapture?.(event.pointerId);
    this.setPosition(this._pointerPercent(event.clientX));
  }

  _onPointerMove(event) {
    if (!this.dragging) return;
    event.preventDefault();
    this.setPosition(this._pointerPercent(event.clientX));
  }

  _onPointerUp() {
    if (!this.dragging) return;
    this.dragging = false;
    this._scheduleResume();
  }

  _onKeyDown(event) {
    if (event.code !== 'ArrowLeft' && event.code !== 'ArrowRight') return;
    event.preventDefault();
    this._pauseInteraction();
    const delta = event.code === 'ArrowLeft' ? -2 : 2;
    if (delta < 0) this.direction = -1;
    if (delta > 0) this.direction = 1;
    this.setPosition(this.position + delta);
    this._scheduleResume();
  }
}

if (!customElements.get('bk-media-image-comparison')) {
  customElements.define('bk-media-image-comparison', BkMediaImageComparison);
}

function initBkMediaImageComparisons() {
  document.querySelectorAll('bk-media-image-comparison').forEach((el) => {
    if (typeof el._setup === 'function') el._setup();
  });
}

document.addEventListener('DOMContentLoaded', initBkMediaImageComparisons);
document.addEventListener('shopify:section:load', initBkMediaImageComparisons);

/* bk-media-widerruf-gate start */
function initWiderrufGate() {
  var drawer = document.getElementById('bk-media-widerruf-gate');
  if (!drawer || drawer.dataset.widerrufGateReady === 'true') return;
  drawer.dataset.widerrufGateReady = 'true';

  var formUrl = drawer.dataset.formUrl || '/apps/widerruf/form';
  var questionPanel = drawer.querySelector('[data-widerruf-panel="question"]');
  var openedPanel = drawer.querySelector('[data-widerruf-panel="opened"]');
  var drawerReady = customElements.whenDefined('x-drawer').then(function() {
    if (typeof customElements.upgrade === 'function') {
      customElements.upgrade(drawer);
    }
    return drawer;
  });

  function resetPanels() {
    if (questionPanel) questionPanel.hidden = false;
    if (openedPanel) openedPanel.hidden = true;
  }

  function openGate() {
    if (drawer.hasAttribute('open')) return;

    resetPanels();

    drawerReady.then(function(readyDrawer) {
      if (readyDrawer.hasAttribute('open')) return;
      if (typeof readyDrawer.show === 'function') {
        readyDrawer.show();
      }
    });
  }

  function goToForm() {
    window.location.href = formUrl;
  }

  document.addEventListener('click', function(event) {
    if (event.defaultPrevented) return;
    var trigger = event.target && event.target.closest
      ? event.target.closest('a[href*="/apps/widerruf"], .widerrufsbutton')
      : null;
    if (!trigger) return;
    if (trigger.closest('#bk-media-widerruf-gate')) return;

    event.preventDefault();
    openGate();
  });

  drawer.querySelectorAll('[data-widerruf-gate="no"]').forEach(function(button) {
    button.addEventListener('click', goToForm);
  });

  drawer.querySelectorAll('[data-widerruf-gate="yes"]').forEach(function(button) {
    button.addEventListener('click', function() {
      if (questionPanel) questionPanel.hidden = true;
      if (openedPanel) openedPanel.hidden = false;
    });
  });

  drawer.querySelectorAll('[data-widerruf-gate="continue"]').forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      goToForm();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWiderrufGate, { once: true });
} else {
  initWiderrufGate();
}

document.addEventListener('shopify:section:load', function() {
  var drawer = document.getElementById('bk-media-widerruf-gate');
  if (drawer) drawer.dataset.widerrufGateReady = 'false';
  initWiderrufGate();
});
/* bk-media-widerruf-gate end */

/* bk-media-batch-announcement start */
function initBkMediaBatch(root) {
  if (root.dataset.bkMediaBatchReady === 'true') return;
  root.dataset.bkMediaBatchReady = 'true';

  var end = new Date(root.dataset.deadline).getTime();
  if (isNaN(end)) return;

  var timer;

  function tick() {
    if (Date.now() < end) return;
    root.classList.add('is-expired');
    if (timer) clearInterval(timer);
  }

  tick();
  if (!root.classList.contains('is-expired')) timer = setInterval(tick, 60000);
}

function initBkMediaBatches() {
  document.querySelectorAll('[data-bk-media-batch]').forEach(initBkMediaBatch);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBkMediaBatches, { once: true });
} else {
  initBkMediaBatches();
}

document.addEventListener('shopify:section:load', initBkMediaBatches);
/* bk-media-batch-announcement end */

/* bk-media-launch-sale start */
(function() {
  var configNode = document.getElementById('onors-launch-sale-config');
  if (!configNode) return;

  var config;

  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    return;
  }

  var code = String(config.code || 'LAUNCH').toUpperCase();
  var minimum = Number(config.minimum) || 5000;
  var giftVariantId = Number(config.giftVariantId) || 57702114230645;
  var qualifyingProductIds = (config.qualifyingProductIds || []).map(Number).filter(Boolean);
  var qualifyingHandles = (config.qualifyingHandles || []).filter(Boolean);
  var goodieKey = '_onors_launch_goodie';
  var busy = false;
  var giftAddBlocked = false;

  if (!qualifyingProductIds.length && !qualifyingHandles.length) {
    qualifyingHandles = ['weight-loss-shot'];
  }

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function inDesignMode() {
    return window.Shopify && Shopify.designMode;
  }

  function celebrate() {
    if (inDesignMode() || !document.body) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.querySelector('.bk-media-launch-confetti')) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'bk-media-launch-confetti';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var context = canvas.getContext('2d');
    if (!context) {
      canvas.remove();
      return;
    }

    var colors = ['#f4c55b', '#2e411a', '#708a5c', '#fafaf7', '#5ad7e0'];
    var pieces = [];
    var started = performance.now();
    var duration = 2400;
    var width = 0;
    var height = 0;

    function resize() {
      var ratio = Math.min(window.devicePixelRatio || 1, 2);
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
    }

    resize();

    for (var index = 0; index < 110; index++) {
      pieces.push({
        x: Math.random() * width,
        y: -16 - Math.random() * height * 0.55,
        size: 6 + Math.random() * 7,
        vx: (Math.random() - 0.5) * 2.2,
        vy: 2.2 + Math.random() * 3.4,
        spin: Math.random() * Math.PI,
        spinSpeed: (Math.random() - 0.5) * 0.22,
        color: colors[index % colors.length]
      });
    }

    function frame(now) {
      context.clearRect(0, 0, width, height);
      pieces.forEach(function(piece) {
        piece.x += piece.vx;
        piece.y += piece.vy;
        piece.vy += 0.045;
        piece.spin += piece.spinSpeed;
        context.save();
        context.translate(piece.x, piece.y);
        context.rotate(piece.spin);
        context.fillStyle = piece.color;
        context.fillRect(-piece.size / 2, -piece.size * 0.35, piece.size, piece.size * 0.7);
        context.restore();
      });

      if (now - started < duration) {
        requestAnimationFrame(frame);
        return;
      }

      canvas.remove();
    }

    requestAnimationFrame(frame);
  }

  function setSaleMode(on) {
    var wasOn = document.documentElement.hasAttribute('data-onors-launch-sale');
    document.documentElement.toggleAttribute('data-onors-launch-sale', !!on);
    if (on && !wasOn) celebrate();
    var bar = document.querySelector('.shopify-section--announcement-bar');
    if (!bar) return;
    document.documentElement.style.setProperty('--announcement-bar-height', Math.round(bar.clientHeight) + 'px');
  }

  function codeApplied(cart) {
    return ((cart && cart.discount_codes) || []).some(function(entry) {
      return String(entry.code || '').toUpperCase() === code;
    });
  }

  function goodieValue(item) {
    var props = item.properties;
    if (!props) return '';
    if (Array.isArray(props)) {
      var found = props.find(function(entry) {
        return entry && (entry.name === goodieKey || entry.first === goodieKey);
      });
      return found ? String(found.value || found.last || '') : '';
    }
    return String(props[goodieKey] || '');
  }

  function isGift(item) {
    return Number(item.variant_id) === giftVariantId;
  }

  function isGoodie(item) {
    return isGift(item) && goodieValue(item) === '1';
  }

  function isQualifying(item) {
    if (qualifyingProductIds.indexOf(Number(item.product_id)) !== -1) return true;
    return qualifyingHandles.indexOf(item.handle) !== -1;
  }

  function plan(cart) {
    var items = (cart && cart.items) || [];
    var on = codeApplied(cart);
    var giftLines = items.filter(isGift);
    var goodieLines = giftLines.filter(isGoodie);
    var manualLines = giftLines.filter(function(item) { return !isGoodie(item); });
    var rest = items.filter(function(item) { return !isGift(item); });
    var total = rest.reduce(function(sum, item) {
      return sum + (Number(item.final_line_price) || 0);
    }, 0);
    var qualifies = on && rest.some(isQualifying) && total >= minimum;
    var updates = {};

    function setQty(line, quantity) {
      if (line.quantity !== quantity) updates[line.key] = quantity;
    }

    if (!on || !qualifies) {
      goodieLines.forEach(function(line) { setQty(line, 0); });
    } else if (!goodieLines.length && !manualLines.length) {
      if (giftAddBlocked) return null;
      return { add: true };
    } else if (goodieLines.length) {
      goodieLines.forEach(function(line, index) { setQty(line, index === 0 ? 1 : 0); });
      manualLines.forEach(function(line) { setQty(line, 0); });
    } else {
      var remaining = 1;
      manualLines.forEach(function(line) {
        var next = Math.min(line.quantity, remaining);
        setQty(line, next);
        remaining -= next;
      });
    }

    if (!Object.keys(updates).length) return null;
    return { updates: updates };
  }

  function sectionIds() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sections }
    }));
    return sections;
  }

  function requestBody(extra) {
    var body = Object.assign({}, extra);
    var sections = sectionIds();
    if (!sections.length) return body;
    body.sections = sections.join(',');
    body.sections_url = window.location.pathname + window.location.search;
    return body;
  }

  function publish(cart, baseEvent) {
    if (cart && cart.sections) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: baseEvent || 'line-item:change',
          cart: cart,
          onorsLaunchSync: true
        }
      }));
      return;
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { onorsLaunchSync: true }
    }));
  }

  async function loadCart() {
    var response = await fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' });
    return response.json();
  }

  async function applyPlan(next) {
    if (next.add) {
      var addedResponse = await fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestBody({
          items: [{
            id: giftVariantId,
            quantity: 1,
            properties: { _onors_launch_goodie: '1' }
          }]
        }))
      });

      if (!addedResponse.ok) {
        giftAddBlocked = true;
        return;
      }

      var added = await addedResponse.json();
      var cart = await loadCart();
      cart.sections = added.sections;
      publish(cart, 'variant:add');
      return;
    }

    var keys = Object.keys(next.updates);
    var cart = null;

    for (var index = 0; index < keys.length; index++) {
      var updatedResponse = await fetch(cartRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody({
          id: keys[index],
          quantity: next.updates[keys[index]]
        }))
      });

      if (!updatedResponse.ok) return;
      cart = await updatedResponse.json();
    }

    if (cart) publish(cart, 'line-item:change');
  }

  async function syncCart(cart) {
    setSaleMode(codeApplied(cart));
    if (inDesignMode()) return;
    var next = plan(cart);
    if (!next || busy) return;
    busy = true;
    try {
      await applyPlan(next);
    } finally {
      busy = false;
    }
  }

  function refreshDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { onorsLaunchSync: true }
    }));
  }

  async function syncFromServer() {
    try {
      var cart = await loadCart();
      var next = !inDesignMode() && plan(cart);
      setSaleMode(codeApplied(cart));
      if (!next) {
        refreshDrawer();
        return;
      }
      await applyPlan(next);
    } catch (error) {
      refreshDrawer();
    }
  }

  document.addEventListener('cart:change', function(event) {
    if (busy || (event.detail && event.detail.onorsLaunchSync)) return;
    var cart = event.detail && event.detail.cart;
    if (!cart || !cart.items) return;
    setSaleMode(codeApplied(cart));
    if (inDesignMode()) return;
    var next = plan(cart);
    if (!next) return;
    busy = true;
    applyPlan(next).finally(function() {
      busy = false;
    });
  }, true);

  document.addEventListener('cart:refresh', function(event) {
    if ((event.detail && event.detail.onorsLaunchSync) || busy) return;
    event.stopPropagation();
    busy = true;
    syncFromServer().finally(function() {
      busy = false;
    });
  }, true);

  document.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('[data-bk-media-discount-apply]');
    if (!button) return;
    var wrap = button.closest('.bk-media-launch-discount');
    var input = wrap && wrap.querySelector('cart-discount-field input:not([type="hidden"])');
    if (!input || !(input.value || '').trim()) return;
    event.preventDefault();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function(event) {
    var field = event.target.closest && event.target.closest('cart-discount-field');
    if (!field) return;
    var input = event.target;
    if (!input || input.tagName !== 'INPUT' || input.type === 'hidden') return;
    if ((input.value || '').trim().toUpperCase() !== code) return;
    event.stopPropagation();
    applyTypedCode(field, input.value.trim());
  }, true);

  async function applyTypedCode(field, typed) {
    field.setAttribute('aria-busy', 'true');
    try {
      var current = await loadCart();
      var codes = (current.discount_codes || []).map(function(entry) { return entry.code; });
      if (!codes.some(function(entry) { return String(entry).toUpperCase() === code; })) codes.push(typed);

      var response = await fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody({ discount: codes.join(',') }))
      });
      var cart = await response.json();
      var accepted = (cart.discount_codes || []).some(function(entry) {
        return String(entry.code || '').toUpperCase() === code;
      });

      if (!response.ok || !accepted) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:discount:error', { bubbles: true }));
        return;
      }

      var visible = field.querySelector('input:not([type="hidden"])');
      if (visible) visible.value = '';
      setSaleMode(true);

      var next = !inDesignMode() && plan(cart);
      if (!next) {
        publish(cart, 'discount:apply');
        return;
      }

      busy = true;
      try {
        await applyPlan(next);
      } finally {
        busy = false;
      }
    } catch (error) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:discount:error', { bubbles: true }));
    } finally {
      field.setAttribute('aria-busy', 'false');
    }
  }

  async function boot() {
    try {
      var params = new URLSearchParams(window.location.search);
      var urlCode = params.get('discount');
      var cart = await loadCart();

      if (urlCode && urlCode.toUpperCase() === code && !codeApplied(cart) && !inDesignMode()) {
        var response = await fetch(cartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody({ discount: urlCode }))
        });
        if (response.ok) cart = await response.json();
      }

      await syncCart(cart);
    } catch (error) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
/* bk-media-launch-sale end */
